import React, { useEffect, useState } from "react";
import { GUARANTEE_DEADLINE } from "./landingNav";

function daysUntilDeadline() {
  const now = new Date();
  const ms = GUARANTEE_DEADLINE.getTime() - now.getTime();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

export function LandingDeadline() {
  const [days, setDays] = useState(() => daysUntilDeadline());

  useEffect(() => {
    const id = window.setInterval(() => setDays(daysUntilDeadline()), 60_000);
    return () => window.clearInterval(id);
  }, []);

  let label;
  if (days > 1) label = `${days} days until the EU guarantee duty`;
  else if (days === 1) label = "1 day until the EU guarantee duty";
  else if (days === 0) label = "EU guarantee duty starts today";
  else label = "EU guarantee duty in force since 27 Sep 2026";

  return (
    <div className="landing-deadline" role="status">
      <span className="landing-deadline__date">27.09.2026</span>
      <span className="landing-deadline__label">{label}</span>
    </div>
  );
}
